import { PartnerType } from 'legacy/lut/classes/models/PartnerType'

import { Nullable } from 'clickNgo/models/utils'
import { deleteParamsFromUrl, getUrlWithParams } from 'core-components/helpers/url'
import {
  NEW_QBR_TEMP_ENTRY_ID,
  QBR_DOCUMENT_URL_IDENTIFIER,
  QBR_DOCUMENT_URL_PID,
  QBR_DOCUMENT_URL_RTM,
  QBR_PAGE,
} from 'partner360/components/QBR/configs'

export const getQbrPageLink = (rtm: Nullable<PartnerType>, predefinedPid?: string) => {
  const newUrlParams = {
    page: QBR_PAGE,
    [QBR_DOCUMENT_URL_IDENTIFIER]: NEW_QBR_TEMP_ENTRY_ID,
    [QBR_DOCUMENT_URL_RTM]: rtm,
  }
  const cleanedUrl = deleteParamsFromUrl(['pid', 'ptype', 'fyear'])
  if (predefinedPid) {
    newUrlParams[QBR_DOCUMENT_URL_PID] = predefinedPid
  }
  return getUrlWithParams(newUrlParams, cleanedUrl)
}
